import type { SVGProps } from 'react'
const SvgSyTechCurveChart = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" width={24} height={24} {...props}>
		<path d="M740.9 696.7c0 24.6-19.9 44.4-44.4 44.4H74.2c-24.6 0-44.4-19.9-44.4-44.4V207.8c0-24.6 19.9-44.4 44.4-44.4h399.1l-26 44.4H74.2v488.9h622.2V393.5h44.4v303.2z" />
		<path
			fillOpacity={0.24}
			d="M140.9 314.5c-9.8 0-17.8-8-17.8-17.8s8-17.8 17.8-17.8h133.3c53.4 0 74.8 37.9 103.4 139.5.9 3.3 2 7.2 4 14.5 1.6 5.8 2.9 10.2 4.1 14.5 29.2 102.1 56.2 142.7 110.7 142.7h133.3c9.8 0 17.8 8 17.8 17.8s-8 17.8-17.8 17.8H496.4c-77 0-111.5-51.8-144.9-168.4-1.2-4.3-2.5-8.8-4.1-14.7-2-7.2-3.1-11.1-4-14.4-23.8-84.6-40.2-113.6-69.2-113.6H140.9z"
		/>
		<path d="M582.1 77.7 455 296.8c-12.3 18.1-.4 42.8 21.4 44.4 1 0 2 .1 3 0h254.4c21.9.7 36.3-22.5 26-41.8-.5-.9-1-1.8-1.6-2.6L631.1 77.7c-11-18.8-38.1-18.8-49.1 0z" />
	</svg>
)
export default SvgSyTechCurveChart
